// extracted by mini-css-extract-plugin
module.exports = {"title":"index-title-2hAWI"};